import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import {
  GetUsersReactionsForMessageRequest,
  GetUsersReactionsForMessageRequestSchema,
} from '../types/message/message_requests_pb';
import { GetUsersReactionsForMessageResponse } from '../types/message/message_responses_pb';
import {
  GetUserReactionsRequest,
  GetUserReactionsRequestSchema,
} from '../types/reaction/reaction_requests_pb';
import { GetUserReactionsResponse } from '../types/reaction/reaction_responses_pb';
import { WsRequest } from './request.types';

export function getUserReactionsRequest(
  data: WsRequest<GetUserReactionsRequest>
): Promise<GetUserReactionsResponse> {
  return wsAppRequestManager.request<GetUserReactionsResponse>({
    case: 'getUserReactions',
    value: create(GetUserReactionsRequestSchema, data),
  });
}

export function getUserReactionsForMessageRequest(
  data: WsRequest<GetUsersReactionsForMessageRequest>
): Promise<GetUsersReactionsForMessageResponse> {
  return wsAppRequestManager.request<GetUsersReactionsForMessageResponse>({
    case: 'getUsersReactionsForMessage',
    value: create(GetUsersReactionsForMessageRequestSchema, data),
  });
}
